export default "__VITE_ASSET__BG$LRwiZ__"